import { render, staticRenderFns } from "./Sounds.vue?vue&type=template&id=01955f3e&"
import script from "./Sounds.vue?vue&type=script&lang=js&"
export * from "./Sounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports